import { axiosApiInstance } from "../App";
import { url } from "./url.service";
const serverUrl = `${url}/notification`;

export const getNotification = async () => {
    // console.log("")
    return await axiosApiInstance.get(`${serverUrl}/`);
};

